import { SxProps, Theme } from '@mui/material';

const popoverContainerSx: SxProps<Theme> = ({ backrs }) => ({
  boxShadow: backrs.shadows['shadow-md'],
  borderRadius: backrs.radius['radius-md'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  border: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
  minWidth: backrs.spacing['spacing-10xl'],
});

const popoverContentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const categoriesContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const categoryItemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingX: backrs.spacing['spacing-xl'],
  paddingY: backrs.spacing['spacing-md'],
  gap: backrs.spacing['spacing-md'],
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
  },
});

const categoryLabelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const categoryIndicatorSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
});

const activeDotSx: SxProps<Theme> = ({ backrs }) => ({
  width: '6px',
  height: '6px',
  borderRadius: backrs.radius['radius-full'],
  backgroundColor: backrs.colors['Colors/Base/Black'],
});

const itemsContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const backButtonSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
  paddingX: backrs.spacing['spacing-lg'],
  paddingY: backrs.spacing['spacing-md'],
  cursor: 'pointer',
  userSelect: 'none',
  borderBottom: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
  '&:hover': {
    backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
  },
});

const backLabelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const filterItemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-md'],
  paddingX: backrs.spacing['spacing-xl'],
  paddingY: backrs.spacing['spacing-md'],
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
  },
});

const itemLabelSx: SxProps<Theme> = ({ backrs }) => ({
  flex: 1,
  color: backrs.colors['Colors/Text/text-secondary'],
});

const checkboxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const clearAllButtonSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingX: backrs.spacing['spacing-xl'],
  paddingY: backrs.spacing['spacing-lg'],
  cursor: 'pointer',
  userSelect: 'none',
  borderTop: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
  '&:hover': {
    backgroundColor: backrs.colors['Colors/Background/bg-secondary'],
  },
  justifyContent: 'flex-end',
});

const clearAllTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-brand-secondary'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  paddingX: backrs.spacing['spacing-xl'],
  paddingY: backrs.spacing['spacing-lg'],
  width: '100%',
  color: backrs.colors['Colors/Text/text-secondary'],
  borderBottom: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
});

export const popoverFilterMenuStyles = {
  popoverContainerSx,
  popoverContentSx,
  categoriesContainerSx,
  categoryItemSx,
  categoryLabelSx,
  categoryIndicatorSx,
  activeDotSx,
  itemsContainerSx,
  backButtonSx,
  backLabelSx,
  filterItemSx,
  itemLabelSx,
  checkboxSx,
  clearAllButtonSx,
  clearAllTextSx,
  titleSx,
};
